import Vue from 'vue'
import Modal from '@/components/modal/Modal.vue'
import InputText from '@/components/inputText/InputText.vue'
import Dropdown from '@/components/dropdown/Dropdown.vue'
import ModalPage from '@/components/modalPage/ModalPage.vue'

export default {
    name: 'user-info',
    inject: ['auth', 'localization'],
    data() {
        return {
            form: {
                object: {
                    name: 'object',
                    validator: { required: true, uniqueObject: true },
                    placeholder: 'Object',
                    value: null,
                }
            },
            editing: false,
            users: [],
            links: [
                { name: 'About SecurOS', alias: 'about' },
                // { name: 'Help', alias: 'help' },
            ],
            lang: {
                active: this.$store.state.i18n.locale,
                modal: false,
                list: [
                    { name: 'en', title: 'EN' },
                    { name: 'ru', title: 'Рус' },
                ]
            }
        }
    },
    created() {
        let usersJson = localStorage.getItem('users')

        if (usersJson) {
            this.users = JSON.parse(usersJson).filter(user => {
                return user.remember === true
            })
        }

        this.$validator.extend('uniqueObject', {
            getMessage: field => 'uniqueObject',
            validate: (value) => {
                return ! this.users.some(item => {
                    return value == item.object
                }) || value == this.$store.state.user.object
            }
        })
    },
    methods: {
        logout() {
            this.auth.logout().then(() => {
                this.$router.push({ name: 'auth' })
            })
        },
        edit() {
            this.form.object.value = this.$store.state.user.object
            this.editing = true

            Vue.nextTick(() => {
                let input = this.$refs['form-object']

                if (input)
                    input.$emit('focus')
            })
        },
        save() {
            let usersJson = localStorage.getItem('users')

            if (usersJson) {
                let users = JSON.parse(usersJson)
                let user = users.find(user => user.login == this.$store.state.user.login)

                if (user) {
                    user.object = this.form.object.value
                    this.$store.commit('setUser', user)
                    localStorage.setItem('users', JSON.stringify(users))
                    this.editing = false
                }
            }
        },
        changeLang() {
            this.localization.set(this.lang.active)
            this.lang.modal = false
        }
    },
    components: {
        Modal,
        InputText,
        Dropdown,
        ModalPage
    }
}



// WEBPACK FOOTER //
// ./src/modules/userInfo/userInfo.js